__turbopack_context__.v({
  "hipaaContent": "hipaa-module-scss-module__5VmwLG__hipaaContent",
});
